import { VehicleConditionType, VehicleConditionTypeEntries } from "Models/VehicleConditionType";
import { Select, Typography } from "antd"
const { Option } = Select;
const { Text } = Typography;

export interface IVehicleConditionTypeSelectBoxProps {
    onChange: (vehicleConditionType: VehicleConditionType) => void;
    vehicleConditionType: VehicleConditionType | null;
    style?: React.CSSProperties;
    label?: string
    allowClear?: boolean;
}

export function VehicleConditionTypeSelectBox(props: IVehicleConditionTypeSelectBoxProps) {
    return (
        <div style={props.style}>
            {props.label && <Text>{props.label}</Text>}
            <Select
                style={{ width: "100%" }}
                onChange={props.onChange}
                value={props.vehicleConditionType}
                allowClear={props.allowClear}
            >
                {VehicleConditionTypeEntries.map(i =>
                    <Option key={i.enumValue} value={i.enumValue}>
                        {i.displayValue}
                    </Option>
                )}
            </Select>
        </div>
    )
} 